import { render, staticRenderFns } from "./PanDetail.vue?vue&type=template&id=3b29977a&scoped=true"
import script from "./PanDetail.vue?vue&type=script&lang=js"
export * from "./PanDetail.vue?vue&type=script&lang=js"
import style0 from "./PanDetail.vue?vue&type=style&index=0&id=3b29977a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29977a",
  null
  
)

export default component.exports